const consolidatedDebtAnalysisTemplate = (() => {
    const main = {
        "1": {
            "config": {
                "class": "container"
            },
            "tag": "div",
            "parent": -1
        },
        "2": {
            "config": {
                "class": "monthly-summery"
            },
            "tag": "div",
            "parent": 1
        },
        "3": {
            "config": {
                "class": "row pt-3"
            },
            "tag": "div",
            "parent": 2
        },
        "4": {
            "config": {
                "class": "col-2"
            },
            "tag": "div",
            "parent": 3
        },
        "5": {
            "config": {
                "class": "pb-0"
            },
            "tag": "h4",
            "parent": 4,
            "html": "Debt Analysis"
        },
        "6": {
            "config": {
                "class": "col-7"
            },
            "tag": "div",
            "parent": 3
        },
        "7": {
            "config": {
                "class": "form-inline"
            },
            "tag": "form",
            "parent": 6
        },
        "8": {
            "config": {
                "class": "input-group mb-2"
            },
            "tag": "div",
            "parent": 7
        },
        "9": {
            "config": {
                "for": "debtAnalysis"
            },
            "tag": "label",
            "parent": 8,
            "html": "Select"
        },
        "10": {
            "config": {
                "class": "custom-select ml-3 accountNumberConsolidatedDebtAnalysisFilter",
                "id": "accountNumberDebtAnalysis"
            },
            "tag": "select",
            "parent": 8,
            "events": [
                {
                    "id": "accountNumberDebtAnalysis",
                    "name": "change",
                    "callback": "getDebtAnalysisSelectedValue"
                }
            ]
        },
        "15": {
            "config": {
                "class": "input-group ml-4 mb-2 sortByMonthOption"
            },
            "tag": "div",
            "parent": 7
        },
        "16": {
            "config": {
                "for": "sortBy"
            },
            "tag": "label",
            "parent": 15,
            "html": "Month-Year"
        },
        "17": {
            "config": {
                "class": "custom-select ml-3 monthConsolidatedDebtAnalysisFilter",
                "id": "monthDebtAnalysis"
            },
            "tag": "select",
            "parent": 15,
            "events": [
                {
                    "id": "monthDebtAnalysis",
                    "name": "change",
                    "callback": "getDebtAnalysisSelectedValue"
                }
            ]
        },
        "18": {
            "config": {
                "class": "input-group ml-4 mb-2"
            },
            "tag": "div",
            "parent": 7
        },
        "19": {
            "config": {
                "for": "debtcategory"
            },
            "tag": "label",
            "parent": 18,
            "html": "Category"
        },
        "20": {
            "config": {
                "class": "custom-select ml-3 debtCategoryConsolidatedDebtAnalysisFilter",
                "id": "categoryDebt"
            },
            "tag": "select",
            "parent": 18,
            "events": [
                {
                    "id": "categoryDebt",
                    "name": "change",
                    "callback": "setDataByDebtCategory"
                }
            ]
        },
        "22": {
            "config": {
                "class": "col-3"
            },
            "tag": "div",
            "parent": 3
        },
        "23": {
            "config": {
                "class": "nav nav-tabs graphicalView float-right"
            },
            "tag": "ul",
            "parent": 22
        },
        "24": {
            "config": {
                "class": "nav-item"
            },
            "tag": "li",
            "parent": 23
        },
        "25": {
            "config": {
                "class": "nav-link glaphicalEvent",
                "id": "hideShowGraphicalView",
                "data-toggle": "tab",
                "href": "#graphicalView"
            },
            "tag": "a",
            "parent": 24,
            "html": "Graphical View",
            "events": [
                {
                    "id": "hideShowGraphicalView",
                    "name": "click",
                    "callback": "hideShowSections"
                }
            ]
        },
        "26": {
            "config": {
                "class": "nav-item"
            },
            "tag": "li",
            "parent": 23
        },
        "27": {
            "config": {
                "class": "nav-link tableview tableEvent",
                "id": "hideShowTableView",
                "data-toggle": "tab",
                "href": "#tableView"
            },
            "tag": "a",
            "parent": 26,
            "html": "Table View",
            "events": [
                {
                    "id": "hideShowTableView",
                    "name": "click",
                    "callback": "hideShowSections"
                }
            ]
        },
        "28": {
            "config": {
                "class": "payment-graph mt-3 hideShowSection1",
                "id": "graphicalView",
            },
            "tag": "div",
            "parent": 1
        },
        "29": {
            "config": {
                "class": "row"
            },
            "tag": "div",
            "parent": 28
        },
        "30": {
            "config": {
                "class": "col-6"
            },
            "tag": "div",
            "parent": 29
        },
        "31": {
            "config": {
                "class": "card p-3 pt-4"
            },
            "tag": "div",
            "parent": 30
        },
        "32": {
            "config": {
                "class": "card-body p-0 text-center"
            },
            "tag": "div",
            "parent": 31
        },
        "33": {
            "config": {},
            "tag": "h6",
            "parent": 32,
            "html": "Count of Payments to Various Lenders Over Time"
        },
        "34": {
            "config": {
                "class": "graph"
            },
            "tag": "div",
            "parent": 32
        },
        "35": {
            "config": {
                "id": "countOfPaymentsPieChart"
            },
            "tag": "div",
            "parent": 34,
            "html": ""
        },
        "51": {
            "config": {
                "class": "chart-legends"
            },
            "tag": "div",
            "parent": 34,
            "html": ""
        },
        "52": {
            "config": {
                "id": "countOfPaymentsPieChartegends"
            },
            "tag": "ul",
            "parent": 51
        },
        "36": {
            "config": {
                "class": "col-6"
            },
            "tag": "div",
            "parent": 29
        },
        "37": {
            "config": {
                "class": "card p-3 pt-4",
            },
            "tag": "div",
            "parent": 36
        },
        "38": {
            "config": {
                "class": "card-body p-0 text-center"
            },
            "tag": "div",
            "parent": 37
        },
        "39": {
            "config": {},
            "tag": "h6",
            "parent": 38,
            "html": "Debt Repaid to Various Lenders Over Time"
        },
        "40": {
            "config": {
                "class": "graph"
            },
            "tag": "div",
            "parent": 38
        },
        "41": {
            "config": {
                "id": "debtRepaidPieChart"
            },
            "tag": "div",
            "parent": 40,
            "html": ""
        },
        "61": {
            "config": {
                "class": "chart-legends"
            },
            "tag": "div",
            "parent": 40,
            "html": ""
        },
        "62": {
            "config": {
                "id": "debtRepaidPieChartLegends"
            },
            "tag": "ul",
            "parent": 61,
            "html": ""
        },
        "42": {
            "config": {
                "id": "tableview",
                "class": "listStatement card p-0 hideShowSection2"
            },
            "tag": "div",
            "parent": 1
        },
        "43": {
            "config": {
                "class": "data-wrap-fixed row m-0"
            },
            "tag": "div",
            "parent": 42
        },
        "44": {
            "config": {
                "class": "col-1 p-0 dataLeft-fixed firstcol dataLeftFixedConsolidatedDebtAnalysis"
            },
            "tag": "div",
            "parent": 43
        },
        "45": {
            "config": {
                "class": "col-1 dataLeft-fixed font-r p-0 dataLeft1FixedConsolidatedDebtAnalysis"
            },
            "tag": "div",
            "parent": 43
        },
        "46": {
            "config": {
                "class": "col-8 p-0"
            },
            "tag": "div",
            "parent": 43
        },
        "47": {
            "config": {
                "class": "mid-panel midPanelConsolidatedDebtAnalysis"
            },
            "tag": "div",
            "parent": 46
        },
        "48": {
            "config": {
                "class": "data-head midPanelDataHeadConsolidatedDebtAnalysis"
            },
            "tag": "div",
            "parent": 47
        },
        "49": {
            "config": {
                "class": "col-1 dataRight-fixed p-0 dataRightFixedConsolidatedDebtAnalysis"
            },
            "tag": "div",
            "parent": 43
        },
        "50": {
            "config": {
                "class": "col-1 dataRight-fixed p-0 dataRight1FixedConsolidatedDebtAnalysis"
            },
            "tag": "div",
            "parent": 43
        }
    };

    return {
        main
    };
})();
